import { Button, Col, Input, Popconfirm, Row, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

export default function CreateAdAcctOffer(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [quantity, setQuantity] = useState('50');
  const [url, setURL] = useState('https://ads.google.com/signup?fna=true&sf=AWN_MULTI_ACCOUNT_SELECTOR&ecl=7696495320%2C7696591668&dst=%2Faw%2Fcampaigns%2Fnew%2Fexpress&subid=us-en-awhp-g-aw-c-home-sso-bgc%21o2-s500g500%7Cib%3A6653296821%7C-ahpm-0000000179-0000000001&authuser=0&_gl=1%2Arhuftr%2A_ga%2AODA1NjEzNTc1LjE3NTk5Nzg1NjQ.%2A_ga_V9K47ZG8NP%2AczE3NTk5Nzg1NjQkbzEkZzEkdDE3NTk5Nzg4NTckajMzJGwwJGgw%2A_ga_J51Y85KVRZ%2AczE3NTk5Nzg1NjQkbzEkZzEkdDE3NTk5Nzg4NTckajMzJGwwJGgw');
  const [messageApi, contextHolder] = message.useMessage();

  const create = async (profile) => {
    messageApi.info(`Profile: ${profile.name} >>> Tạo TK Đơn Offer...`);
    let body = {
      profile: profile,
      quantity: +quantity,
      url: url
    };
    axios
      .post(`${API_HOST}/api/account/create-ad-acct-offer`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Tạo TK Đơn (Offer) ~ e:", e);
        messageApi.error(e.response.data);
      });
  };


  useEffect(() => {
    let url = localStorage.getItem('create-acct-offer-url')
    if(url) {
      setURL(url)
    }
    let quantity = localStorage.getItem('create-acct-offer-quantity')
    if(quantity) {
      setQuantity(quantity)
    }
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Tạo TK Ads (URL Offer)"
        description={
          <>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <br />
            <Row>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={url}
                  placeholder="URL ..."
                  onChange={(e) => {
                    setURL(e.target.value);
                    localStorage.setItem('create-acct-offer-url', e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col span={4}>
                <label>SL: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={quantity}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value);
                    localStorage.setItem('create-acct-offer-quantity', e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            
          </>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button type="primary" loading={loading}>
          Tạo TK Ads (Link)
        </Button>
      </Popconfirm>
    </>
  );
}
